import { userRequest } from "../../store/http.service";
import {
  GET_TERMS_AND_CONDITIONS,
  GET_PRIVACY_POLICY,
  GET_HELP_SUPPORT,
  GET_CONSENT,
  CREATE_OR_UPDATE_LEGAL
} from "../../api/api";

const LegalService = {
  getPrivacyPolicy: () => {
    return userRequest.get(GET_PRIVACY_POLICY);
  },

  getTermsAndConditions: () => {
    return userRequest.get(GET_TERMS_AND_CONDITIONS);
  },

  getHelpSupport: () => {
    return userRequest.get(GET_HELP_SUPPORT);
  },

  getConsent: () => {
    return userRequest.get(GET_CONSENT);
  },

  createOrUpdateContent: (data) => {
    return userRequest.post(CREATE_OR_UPDATE_LEGAL, data);
  }
};

export default LegalService;
